import { ReturnDeductionTaxTypes } from "../../../../types";
export const getTaxDeductAmount = (bet) => {
    const taxDeductionTypes = Object.values(ReturnDeductionTaxTypes);
    return bet.taxes.reduce((prevAmount, currTax) => {
        const currentAmount = taxDeductionTypes.includes(currTax.category) ? currTax.amount : 0;
        return prevAmount + currentAmount;
    }, 0);
};
//# sourceMappingURL=getTaxDeductAmount.js.map